<template>
  <div
    class="main-wrapper"
  >
<!--    New request view-->
    <template
      v-if="$route.query.category === 'request_new' && !$route.query.request_type"
    >
      <new-request-view/>
    </template>
<!--    Details view-->
    <template
      v-else
    >
      <tabs-layout
        :config="detailsConfig"
        :create-mode="$route.query.category === 'request_new'"
        :first-tab-key="$route.query.open_tab || $route.meta.open_tab"
        :redirect-view-name="$route.meta.redirectViewName || null"
        :refresh-tabs="tabsForRefresh"
      >
        <template
          #dynamic-content
        >
          <complete-data-dialog
            v-if="completeDataDialogConfig.showDialog"
            :show-dialog="completeDataDialogConfig.showDialog"
            :config="completeDataDialogConfig.config"
            @close="onCompleteDialogClose"
          />

          <upload-document-dialog
            v-if="uploadSketchDialogConfig.showDialog"
            :show-dialog="uploadSketchDialogConfig.showDialog"
            :config="uploadSketchDialogConfig.config"
            @close="onUploadSketchClose"
          />

          <choose-solution-type-dialog
            v-if="chooseSolutionTypeDialogConfig.showDialog"
            :show-dialog="chooseSolutionTypeDialogConfig.showDialog"
            :config="chooseSolutionTypeDialogConfig.config"
            @close="onChooseSolutionTypeDialogClose"
          />

          <change-status-dialog
            v-if="changeStatusDialogConfig.showDialog"
            :show-dialog="changeStatusDialogConfig.showDialog"
            :title="changeStatusDialogConfig.title"
            :callback="changeStatusDialogConfig.callback"
            :show-loader="changeStatusDialogConfig.showLoader"
            :close-dialog-callback="changeStatusDialogConfig.closeDialogCallback"
            :current-status-id="changeStatusDialogConfig.currentStatusId"
            :statuses="changeStatusDialogConfig.statuses"
          />

          <information-dialog
            v-if="informationDialogConfig.showDialog"
            :open-dialog="informationDialogConfig.showDialog"
            :dialog-message="informationDialogConfig.message"
            :title="informationDialogConfig.title"
            :positive-button-text="informationDialogConfig.positiveButtonText"
            :negative-button-text="informationDialogConfig.negativeButtonText"
            :confirmCallbackFunction="informationDialogConfig.confirmCallbackFunction"
            @close="onCloseInformationDialog"
          />
          <input
            type="file"
            ref="file_input"
            class="d-none"
            accept="application/pdf"
            enctype="multipart/form-data"
            multiple
            @change="event => onDocumentInput(event)"
          />
        </template>
      </tabs-layout>
    </template>
  </div>
</template>

<script>
import NewRequestView from '../components/NewRequestView.vue'
import TabsLayout from '@/global/components/view-layouts/tabs-layout/views/TabsLayout.vue'
import basicInfo from '../config/edit/basicInfo'
import RowBlocksData from '../components/RowBlocksData.vue'
import TabActionButtonsWithTitle from '@/global/components/view-layouts/tabs-layout/components/TabActionButtonsWithTitle.vue'
import columnsContent from '@/global/components/view-layouts/tabs-layout/components/tab-content-types/ColumnsContent.vue'
import dataFromRequest from '../config/edit/dataFromRequest'
import store from '@/global/store'
import anticipatedDamage from '../components/AnticipatedDamage.vue'
import { api } from '@/global/services/api'
import conclusionOnAmendment from '../config/edit/conclusionOnAmendment'
import invitationToInspection from '../config/edit/invitationToInspection'
import inspectionReport from '../config/edit/inspectionReport'
import decisions from '../config/edit/decisions'
import CompleteDataDialog from '../components/CompleteDataDialog.vue'
import sketch from '../config/edit/sketch'
import UploadDocumentDialog from '../components/UploadDocumentDialog.vue'
import solution from '../config/edit/solution'
import ChooseSolutionTypeDialog from '../../solutions/components/ChooseSolutionTypeDialog.vue'
import approval from '../../common/config/edit/approval'
import accountingFieldsRow from '../../approvals/components/AccountingFieldsRow.vue'
import conditionFieldsRow from '../../approvals/components/ConditionFieldsRow.vue'
import roadInformation from '../config/edit/roadInformation'
import changeStatusDialog from '../components/ChangeStatusDialog.vue'
import globalStates from '../global-states'
import informationDialog from '@/global/components/view-layouts/tabs-layout/components/dialogs/InformationDialog.vue'
import documentsGenerationDropdownMenu from '../components/DocumentsGenerationDropdownMenu.vue'

const QUERY_REQUEST_TYPES = ['TEMPORARY_TRAFFIC_REGULATION', 'TEMPORARY_TRAFFIC_REGULATION_EXCAVATION']
const QUERY_CATEGORY = ['request_new', 'request_overview']
const REFRESH_BTN_TIMEOUT = 500
export default {
  name: 'AggregatorRequestDetails',

  components: {
    informationDialog,
    changeStatusDialog,
    UploadDocumentDialog,
    CompleteDataDialog,
    TabsLayout,
    NewRequestView,
    ChooseSolutionTypeDialog
  },

  mixins: [
    basicInfo,
    dataFromRequest,
    conclusionOnAmendment,
    invitationToInspection,
    inspectionReport,
    decisions,
    sketch,
    solution,
    approval,
    roadInformation,
    globalStates
  ],

  data () {
    return {
      rowBlocksDataComponent: RowBlocksData,
      tabActionsComponent: TabActionButtonsWithTitle,
      columnsContentComponent: columnsContent,
      locationInformationComponent: () => import('../components/LocationInformation.vue'),
      attachmentsComponent: () => import('../components/Attachments.vue'),
      anticipatedDamageComponent: anticipatedDamage,
      documentsGenerationDropdownMenuComponent: documentsGenerationDropdownMenu,
      rehabilitationTooltipComponent: () => import('../components/RehabilitationTooltip.vue'),
      documentPreviewComponent: () => import('../components/DocumentPreview.vue'),
      informationAboutRouteComponent: () => import('../../road-information/components/InformationAboutRoute.vue'),
      drawRoadRegulationComponent: () => import('../../road-information/components/DrawRoadRegulation.vue'),
      edit: false,
      dropdownValues: {},
      completeDataDialogConfig: {
        showDialog: false,
        config: {}
      },
      uploadSketchDialogConfig: {
        showDialog: false,
        config: {}
      },
      chooseSolutionTypeDialogConfig: {
        showDialog: false,
        config: {}
      },
      accountingFieldsRowComponent: accountingFieldsRow,
      conditionFieldsRowComponent: conditionFieldsRow,
      changeStatusDialogConfig: {
        showDialog: false,
        title: this.$t('fleet/documents/prl_cargo.select_new_status'),
        currentStatusId: null,
        statuses: [],
        showLoader: false,
        callback: (event) => this.onChangeStatusCallback(event),
        closeDialogCallback: () => this.onCloseChangeStatusCallback()
      },
      informationDialogConfig: {
        showDialog: false,
        message: '',
        title: this.$t('road-maintenance/aggregator.status_change'),
        positiveButtonText: this.$t('base.save'),
        negativeButtonText: this.$t('base.cancel'),
        confirmCallbackFunction: () => this.onChangeStatusCallback(null, true)
      },
      tabsForRefresh: [],
      afterDocumentStatusChangeActions: {},
      refreshTabBtnTimeout: REFRESH_BTN_TIMEOUT
    }
  },

  computed: {
    detailsConfig () {
      return {
        tabs: [
          this.basicInfo,
          this.dataFromRequest,
          this.conclusion,
          this.invitationToInspectionConfig,
          this.inspectionReportConfig,
          this.decisionsConfig,
          this.sketchConfig,
          this.solutionConfig,
          this.approvalConfig,
          this.roadInformation
        ],
        breadcrumbs: {
          items: [
            {
              text: this.$t('road-maintenance.eRegulation')
            },
            {
              text: this.$t(this.$route.meta.breadcrumb_value)
            },
            {
              text: this.$route?.params?.id ?? (this.$route.query.category === 'request_new' ? this.$t('road-maintenance/aggregator.new_request_card_title') : this.$t('road-maintenance/aggregator.request_edit')),
              bolded: true
            }
          ]
        }
      }
    }
  },

  beforeCreate () {
    const { request_type: requestType, category } = this.$route?.query || {}
    if (requestType && !QUERY_REQUEST_TYPES.includes(requestType)) {
      store.dispatch('base/notifications/push', this.$t('road-maintenance/aggregator.wrong_request_type'))
      this.$router.push({
        name: 'Aggregator_requests'
      }).then()
    }
    else if (category && !QUERY_CATEGORY.includes(category)) {
      store.dispatch('base/notifications/push', this.$t('road-maintenance/aggregator.wrong_query_category'))
      this.$router.push({
        name: 'Aggregator_requests'
      }).then()
    }
  },

  async created () {
    try {
      const { data } = await api('road-maintenance').get('traffic-regulation/codebook')
      this.dropdownValues = data ?? data
    }
    catch (exception) {
      console.error(exception)
    }
  },

  methods: {
    pushNotification (message) {
      if (message) {
        store.dispatch('base/notifications/push', message)
      }
    },

    onCompleteDialogClose (event) {
      this.completeDataDialogConfig.showDialog = false
      const { showButton, type, data, updateData } = event || {}

      if (!showButton) {
        const visibilityMap = {
          applicant: 'showApplicationModifyBtn',
          investor: 'showInvestorModifyBtn',
          contractor: 'showContractorModifyBtn',
          'installation-owner': 'authorizedVisible'
        }

        const property = visibilityMap[type]
        if (property && Object.prototype.hasOwnProperty.call(this, property)) {
          this[property] = false
        }

        this.onDataFetched({
          data,
          updateData
        })
      }
    },

    onUploadSketchClose () {
      this.$set(this.uploadSketchDialogConfig, 'showDialog', false)
    },

    onChooseSolutionTypeDialogClose () {
      this.$set(this.chooseSolutionTypeDialogConfig, 'showDialog', false)
    },

    async onChangeStatus () {
      try {
        this.$set(this.changeStatusDialogConfig, 'currentStatusId', this.globalSelectedStatusId)
        this.$set(this.changeStatusDialogConfig, 'showDialog', true)

        if (!this.changeStatusDialogConfig.statuses.length) {
          this.$set(this.changeStatusDialogConfig, 'showLoader', true)
          const { data: availableStatuses } = await api('road-maintenance').get('traffic-regulation/statuses', {
            status_id: this.globalSelectedStatusId
          })

          if (availableStatuses && availableStatuses.length) {
            this.$set(this.changeStatusDialogConfig, 'statuses', availableStatuses)
            this.$set(this.changeStatusDialogConfig, 'showLoader', false)
          }
        }
      }
      catch (exception) {
        console.error(exception)
      }
    },

    async onChangeStatusCallback (event, isInformationDialog = false) {
      try {
        const { statusId } = event || {}
        const { statusId: documentStatusChangeId } = this.afterDocumentStatusChangeActions || {}
        const statusIdToChange = statusId || documentStatusChangeId || null
        if (!statusIdToChange) return

        this.globalSelectedStatusId = statusIdToChange
        const formData = new FormData()
        formData.append('_method', 'PATCH')
        formData.append('status_id', statusIdToChange)

        await api('road-maintenance').post(`traffic-regulation/${this.$route.params.id}/update-status`, formData)
        // Refresh basic info tab after status change
        this.tabsForRefresh = [...['basic-info']]

        // Check is document status changing
        if (isInformationDialog) {
          this.$set(this.informationDialogConfig, 'showDialog', false)
          this.afterDocumentStatusChangeActions = {}
        }
        else {
          this.$set(this.changeStatusDialogConfig, 'showDialog', false)
        }
      }
      catch (exception) {
        console.error(exception)
      }
    },

    onCloseChangeStatusCallback () {
      this.$set(this.changeStatusDialogConfig, 'showDialog', false)
    },

    onCloseInformationDialog () {
      this.$set(this.informationDialogConfig, 'showDialog', false)
      this.afterDocumentStatusChangeActions = {}
    }
  }
}
</script>

<style scoped>
@import "../styles/documentsHistoryBlocks.css";
@import "../styles/documents.css";
.main-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  background-color: #F3F4F6;
}

::v-deep {
  .modified-title {
    font-family: 'Satoshi', sans-serif !important;
    font-size: 20px !important;
    font-weight: 500;
    color: #09090B;
  }

  .generate-document-btn {
    color: #FFFFFF;
  }

  .time-period-text {
    font-family: 'Satoshi', sans-serif !important;
    font-weight: 500 !important;
    font-size: 16px !important;
    line-height: 24px !important;
    color: #09090B;
  }

  .time-period-column {
    padding-bottom: 0;
  }
}
</style>
